import { FC } from 'react';
import React from 'react';

export const Regex: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vQ8f5oWnmW6pire3fsMKkGRcoU_ZA3a7SzyzdeA03hzrfDaNDyR2RJ73o_PL8ywA5-eDxgHGwY8LomE/embed?start=false&loop=false&delayms=60000" allowFullScreen 
                width="1200" height="675">

                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};
